<div class="container">
  <div class="single_element">
    <div class="quick_activity">
      <h5>المنصة العلاجية</h5>

      <div class="quick_activity_wrap">
        <div class="row g-24">
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-1">
              <div class="icon">
                <img src="assets/images/icons/stethoscope-icon.svg" alt="" />
              </div>
              <h3>قائمة المستخدمين</h3>
              <a routerLink="/admin/users">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-2">
              <div class="icon">
                <img
                  src="assets/images/icons/medicine-icon-orange.svg"
                  alt=""
                />
              </div>
              <h3>قائمة المرضى</h3>
              <a routerLink="/auth/basic-data/PatientsView">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-3">
              <div class="icon">
                <img src="assets/images/icons/list-icon-info.svg" alt="" />
              </div>
              <h3>قائمة المتخصصين</h3>
              <a routerLink="/Sas/Spcialist-schedule">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-4">
              <div class="icon">
                <img
                  src="assets/images/icons/microscope-icon-dark.svg"
                  alt=""
                />
              </div>
              <h3>قائمة المشرفين</h3>
              <a routerLink="/Sas/SupervaisorView">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-5">
              <div class="icon">
                <img src="assets/images/icons/computer-yellow.svg" alt="" />
              </div>
              <h3>حسابات زووم</h3>
              <a routerLink="/admin/ZoomUsers">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-6">
              <div class="icon">
                <img src="assets/images/icons/coins-lavender.svg" alt="" />
              </div>
              <h3>باقات الدفع</h3>
              <a routerLink="/Sas/Subscriptions-View">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>

          <!-- <div class="col-lg-4">
            <a routerLink="/admin/users">
              <div class="single_quick_activity">
                <img src="assets/images/2.png" class="img-fluid" width="50" />
                <h3>قائمة المستخدمين</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/auth/basic-data/PatientsView">
              <div class="single_quick_activity single_quick_activity5">
                <img src="assets/images/5.png" class="img-fluid" width="50" />
                <h3>قائمة المرضى</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/Sas/Spcialist-schedule">
              <div class="single_quick_activity single_quick_activity3">
                <img src="assets/images/7.png" class="img-fluid" width="50" />
                <h3>قائمة المتخصصين</h3>
              </div>
            </a>
          </div> -->
        </div>

        <!-- <div class="row">
          <div class="col-lg-4">
            <a routerLink="/Sas/SupervaisorView">
              <div class="single_quick_activity single_quick_activity2">
                <img src="assets/images/1.png" class="img-fluid" width="50" />
                <h3>قائمة المشرفين</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/admin/ZoomUsers">
              <div class="single_quick_activity single_quick_activity4">
                <img src="assets/images/8.png" class="img-fluid" width="50" />
                <h3>حسابات زووم</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/Sas/Subscriptions-View">
              <div class="single_quick_activity single_quick_activity6">
                <img
                  src="assets/images/money-icon.png"
                  class="img-fluid"
                  width="50"
                />
                <h3>باقات الدفع</h3>
              </div>
            </a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
